import { render, staticRenderFns } from "./ProtocolloModuliList.vue?vue&type=template&id=4a5c3dd4"
import script from "./ProtocolloModuliList.vue?vue&type=script&lang=js"
export * from "./ProtocolloModuliList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports